"use strict";
// import request from "./api";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArray = exports.time = exports.showDate = exports.format = exports.throttleLoad = exports.lazyload = void 0;
var lazyload = function (time) {
    if (!time)
        time = 50;
    var timeObj;
    return function (cb, time2) {
        if (time2 === void 0) { time2 = time; }
        if (typeof cb != "function")
            return;
        clearInterval(timeObj);
        timeObj = setTimeout(cb, time2);
    };
};
exports.lazyload = lazyload;
//节流加载( 规定时间内只执行最早的一次)
var throttleLoad = function (duration) {
    if (!duration) {
        duration = 200;
    }
    var last;
    return function (cb, duration2) {
        if (duration2 === void 0) { duration2 = duration; }
        var now = Date.now();
        if (last && (now - last) < duration2)
            return;
        last = now;
        typeof cb == 'function' && cb();
    };
};
exports.throttleLoad = throttleLoad;
var format = function (date, fmt) {
    var o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3),
        "S": date.getMilliseconds() // 毫秒
    };
    // 根据y的长度来截取年
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
    return fmt;
};
exports.format = format;
// String.prototype['dateformat'] = function (format: string) {
//   let str = this.toString()
//   if (str.indexOf('T') == -1) {
//     str = str.replace(/-/g, '/')
//   }
//   else {
//     str = str.replace('T', ' ').replace(/-/g, '/')
//   }
//   let date: any = new Date(str)
//   if (format) {
//     return date.format(format)
//   }
//   else {
//     return str
//   }
// }
// Date.prototype['format'] = function (format: string): string {
//   let date = this
//   var map = {
//     "M": date.getMonth() + 1, //月份
//     "d": date.getDate(), //日
//     "h": date.getHours(), //小时
//     "m": date.getMinutes(), //分
//     "s": date.getSeconds(), //秒
//     "q": Math.floor((date.getMonth() + 3) / 3), //季度
//     "S": date.getMilliseconds() //毫秒
//   };
//   format = format.replace(/([yMdhmsqS])+/g, (all, t) => {
//     var v = map[t];
//     if (v !== undefined) {
//       if (all.length > 1) {
//         v = '0' + v;
//         v = v.substr(v.length - 2);
//       }
//       return v;
//     } else if (t === 'y') {
//       return (date.getFullYear() + '').substr(4 - all.length);
//     }
//     return all;
//   });
//   return format;
// }
// Array.prototype['distinct'] = function (key: string): any {
//   var result = [];
//   var obj = {};
//   for (var i = 0; i < this.length; i++) {
//     if (!obj[this[i][key]]) {
//       result.push(this[i]);
//       obj[this[i][key]] = true;
//     }
//   }
//   return result
// }
// Array.prototype['select'] = function (name: string) {
//   if ((this) instanceof Array) {
//     let arrs = [];
//     for (var i = 0; i < this.length; i++) {
//       if (this[i][name] != undefined) {
//         arrs.push(this[i][name]);
//       }
//     }
//     return arrs.toString();
//   }
//   return "";
// }
function showDate(date1, date2, format, format2) {
    if (format === void 0) { format = 'yyyy-MM-dd'; }
    if (format2 === void 0) { format2 = 'hh:mm'; }
    if (!date1 || !date2) {
        return '';
    }
    var startDate = date1;
    var endtDate = date2;
    var t1 = startDate.dateformat('yyyy-MM-dd');
    var t2 = startDate.dateformat(format2);
    var t3 = endtDate.dateformat('yyyy-MM-dd');
    var t4 = endtDate.dateformat(format2);
    if (format) {
        t1 = startDate.dateformat(format);
        t3 = endtDate.dateformat(format);
    }
    return t1 == t3 ? "".concat(t1, " ").concat(t2, " - ").concat(t4) : "".concat(t1, " ").concat(t2, " \u81F3 ").concat(t3, " ").concat(t4);
}
exports.showDate = showDate;
function time(nS) {
    var viewtime = new Date(parseInt(nS) * 1000);
    var result;
    var viewtimeArr;
    viewtimeArr = [viewtime.getFullYear(), viewtime.getMonth() + 1, viewtime.getDate()];
    var nowDate = new Date();
    var year = nowDate.getFullYear();
    var month = nowDate.getMonth() + 1;
    var day = nowDate.getDate();
    if (year == viewtimeArr[0]) {
        if (month == viewtimeArr[1] && day - viewtimeArr[2] < 2) {
            if (day - viewtimeArr[2] === 1)
                result = "\u6628\u5929";
            else
                result = "\u4ECA\u5929";
        }
        else {
            result = "".concat(viewtimeArr[1], "-").concat(viewtimeArr[2]);
        }
    }
    else {
        result = "".concat(viewtimeArr[0], "-").concat(viewtimeArr[1], "-").concat(viewtimeArr[2]);
    }
    // console.log(viewtime, year, month, day, viewtimeArr)
    return result;
}
exports.time = time;
var isArray = function (value) {
    if (typeof Array.isArray === "function") {
        return Array.isArray(value);
    }
    else {
        return Object.prototype.toString.call(value) === "[object Array]";
    }
};
exports.isArray = isArray;
//# sourceMappingURL=data:application/json;base64,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